import { toReadableValue } from '@ui/lib/bignumber';
import { PossibleBigNumber } from '@ui/types/utility';
import BigNumber from 'bignumber.js';
import { useGasPrice } from 'wagmi';

import { useNativeToken } from './useNativeToken';
import { useNativeTokenPrice } from './useNativeTokenPrice';

const DEFAULT_GAS_FEE = new BigNumber(0.2); // 0.2MON

export const useGasFee = (gasLimit: PossibleBigNumber) => {
  const { decimals } = useNativeToken();
  const nativeTokenPrice = useNativeTokenPrice();

  return useGasPrice({
    query: {
      select: (price) => {
        const gasInNativeToken = gasLimit
          ? toReadableValue(price, decimals).times(gasLimit.toString())
          : DEFAULT_GAS_FEE;
        const gasInUsd = nativeTokenPrice
          ? gasInNativeToken?.times(nativeTokenPrice)
          : undefined;

        return {
          gasInNativeToken,
          gasInUsd,
        };
      },
    },
  });
};
